import { mapActions } from 'vuex';

const comment_mixins = {       
  methods: {
    ...mapActions('comment_store', ['ACT_comment']),
    MIX_comment (payload){
        this.ACT_comment(payload);
    }
  }
}

export default {
    install (Vue, options) {
        Vue.mixin(comment_mixins)
    }
};

 

  
  